import React, { Component } from 'react';
import classNames from 'classnames';
import { LinkContainer } from 'react-router-bootstrap';
import styles from './styles.module.scss';
import deeperLearning from 'assets/videos/deeper-learning-students.mp4';
import deeperLearningPoster from 'assets/img/deeper-learning-poster.png';
import engagement from 'assets/videos/engagement-students.mp4';
import engagementPoster from 'assets/img/engagement-students-poster.png';
import buildSkills from 'assets/videos/build-skills-students.mp4';
import buildSkillsPoster from 'assets/img/build-skills-poster.png';
import emailRegex from 'utils/emailRegex';
import FormWithValidations from 'components/form-with-validations';

const benefitsPageData = {
  engagement: {
    title: 'Student engagement more important than ever',
    subtitle:
      '<em>Genuine</em> engagement is the starting point for effective instruction',
    listItems: [
      'Our unique group learning scenarios and activities keep students present, passionate and in mental control throughout each step. These are the base elements of student engagement.',
      'Some studies show 50% or more of all students are disengaged (Gallup 2015). With Unyted activities, students are placed in scenarios where they keep each other accountable for 100% group participation.',
      "Unyted activities apply to <em>everyone</em> in the lesson - not just the disengaged. Even successful students often describe their learning experience as 'boring, hectic, stressful and disconnected from the real world' (Dunleavy & Milton, 2009, p. 11).",
    ],
    video: engagement,
    poster: engagementPoster,
  },
  'deeper-learning': {
    title: 'Easier way to go beyond rote memorization',
    subtitle: 'Successful test scores, but also stronger foundation',
    listItems: [
      'Unyted places students in scenarios encouraging explanation of concepts to each other. When there are gaps in understanding, they become easier for teachers to identify and remedy.',
      "Unyted's unique group learning exercises require students work together to move forward. Existing users explain how this increases critical thinking when choosing answer choices.",
      '<em>Understanding</em>, instead of rote memorization, has already been shown as a better foundation for future success on both tests and in subsequent courses.',
    ],
    video: deeperLearning,
    poster: deeperLearningPoster,
  },
  'build-skills': {
    title: 'The movement is now here and growing',
    subtitle:
      'Focusing on personal skills along with strong academics is now critical',
    listItems: [
      "Unyted's group learning activities are aligned with the evidence-based 5 CASEL core competencies. Learn more at this link: <a href='https://casel.org/core-competencies/'>The Five Core Competencies.</a>",
      'Save yourself time, effort and resources by using Unyted activities where academic instruction is combined with opportunities for social-emotional development.',
      "Evidence shows it's more effective to develop relevant social, emotional and modern skills through experiences with peers.",
    ],
    video: buildSkills,
    poster: buildSkillsPoster,
  },
};

const validations = {
  name: value => Boolean(value),
  email: value => emailRegex.test(value),
};

class BenefitsPage extends Component {
  createHtml(text) {
    return <span dangerouslySetInnerHTML={{ __html: text }} />;
  }

  scrollToContact = () => {
    const contactForm = document.getElementById('contact-form');
    if (!contactForm) {
      setTimeout(this.scrollToContact, 300);
    }

    contactForm.scrollIntoView();
  };

  render() {
    const { match, fields, errors, handleSubmit, handleChange } = this.props;
    const { name, email, school, message } = fields;
    const data = benefitsPageData[match.params.type];

    return (
      <div className={`${styles.mainContent} row`}>
        <div className="col-12">
          <div className={`${styles.headerRow} row`}>
            <div className={`${styles.heading} col-12 text-center`}>
              <h2 className={`${styles.titletown}`}>
                {this.createHtml(data.title)}
              </h2>
            </div>
            <div className={`${styles.imageContainer} col-12 col-sm-6`}>
              <video
                className={styles.mainVideo}
                src={data.video}
                poster={data.poster}
                controls={true}
              />
            </div>
            <div className={`${styles.list} col-12 col-sm-6`}>
              <h2>{this.createHtml(data.subtitle)}</h2>
              <ul>
                {data.listItems.map((item, index) => (
                  <li key={index}>{this.createHtml(item)}</li>
                ))}
              </ul>
              <LinkContainer to="/community-onboard">
                <button className={`${styles.learnMore} btn btn-primary`}>
                  Start Your Free Trial Community
                </button>
              </LinkContainer>
            </div>
          </div>
        </div>
        <div id="contact-form" className={`${styles.formContainer} col-sm-12`}>
          <form className={styles.landingForm} onSubmit={handleSubmit}>
            <h2>Contact Us!</h2>
            <div
              className={classNames({
                'form-group': true,
                [styles.error]: errors.name,
              })}
            >
              <label htmlFor="name">Name*</label>
              <input
                name="name"
                type="text"
                className="form-control"
                id="name"
                onChange={handleChange}
                value={name}
              />
              <p>Name is required</p>
            </div>
            <div
              className={classNames({
                'form-group': true,
                [styles.error]: errors.email,
              })}
            >
              <label htmlFor="email">Email*</label>
              <input
                name="email"
                type="email"
                className="form-control"
                id="email"
                onChange={handleChange}
                value={email}
              />
              <p>Invalid email format</p>
            </div>
            <div className="form-group">
              <label htmlFor="school">School</label>
              <input
                name="school"
                type="school"
                className="form-control"
                id="school"
                onChange={handleChange}
                value={school}
              />
            </div>
            <div className="form-group">
              <label htmlFor="message">Any Questions?</label>
              <textarea
                name="message"
                className="form-control"
                onChange={handleChange}
                value={message}
              />
            </div>

            <span className={styles.required}>* Required</span>
            <button type="submit" className={`${styles.submitButton}`}>
              Submit
            </button>
          </form>
        </div>
      </div>
    );
  }
}
const ValidatedBenefitsPage = FormWithValidations(
  BenefitsPage,
  { name: '', email: '', school: '', message: '' },
  validations,
);

export default ValidatedBenefitsPage;
